import { ls } from '@clofo/data/local-storage'

export type TfaSession = { status: 'enforced' } | { status: 'enabled'; tfaSecretUri: string }

/**
 * The pending two-factor session left behind by the password step: the obtain token, stored while
 * its tfa_status still requires a second factor. Note the counter-intuitive legacy naming —
 * 'enforced' means the user already has TFA configured and just enters a code, while 'enabled'
 * means they still need to set it up (and therefore needs the token's tfa_secret_uri; without it
 * there is no usable pending session). Any other status means no TFA step is pending.
 */
export const getTfaSession = (): TfaSession | null => {
  const token = ls.getItem('clofoToken')
  if (!token) return null
  if (token.tfa_status === 'enforced') return { status: 'enforced' }
  if (token.tfa_status === 'enabled' && token.tfa_secret_uri) {
    return { status: 'enabled', tfaSecretUri: token.tfa_secret_uri }
  }
  return null
}
